import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-section03',
  templateUrl: './section03.component.html',
  styleUrls: ['./section03.component.scss']
})

export class Section03Component implements OnInit {
  @Input() data;

  constructor() {
  }

  ngOnInit() {
  }

}
